export default class State {
  constructor(name, abbreviation) {
    this.abbreviation = abbreviation;
    this.name = name;
  }
}
